import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock, Facebook, Instagram } from "lucide-react";
import { useShop } from "../context/ShopContext";

const SOCIAL_LINKS = [
  {
    href: "https://www.facebook.com/puntogommelaziosrl/",
    label: "Facebook",
    Icon: Facebook,
  },
  {
    href: "https://www.instagram.com/puntogommelaziosrl/",
    label: "Instagram",
    Icon: Instagram,
  },
];

export default function Footer() {
  const { salesEnabled } = useShop();

  return (
    <footer className="bg-pg-dark text-gray-400" style={{ contain: "layout" }}>
      {/* Accent line */}
      <div className="h-px bg-gradient-to-r from-transparent via-pg-red/40 to-transparent" />

      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 xl:grid-cols-5 gap-8 mb-10">
          {/* Brand */}
          <div className="col-span-2 md:col-span-4 xl:col-span-1">
            <img src="/images/pg-logo.webp" alt="Puntogomme Lazio" width={200} height={40} loading="lazy" decoding="async" className="h-10 w-auto mb-4" />
            <p className="text-sm leading-relaxed text-gray-400 max-w-xs">
              Vendita pneumatici, assistenza auto e servizi di meccanica nel Lazio dal 1990.
            </p>
            <div className="flex gap-3 mt-4">
              {SOCIAL_LINKS.map(({ href, label, Icon }) => (
                <a
                  key={href}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  className="w-9 h-9 rounded-xl bg-white/5 flex items-center justify-center hover:bg-pg-red/20 hover:text-pg-red transition-all duration-150"
                >
                  <Icon size={16} />
                </a>
              ))}
            </div>
          </div>

          {/* Links */}
          <div>
            <h2 className="text-white font-bold text-xs uppercase tracking-widest mb-4">{salesEnabled ? "Shop" : "Account"}</h2>
            <ul className="space-y-2.5 text-sm">
              {salesEnabled && (
                <>
                  <li><Link to="/prodotti" className="hover:text-white transition-colors">Pneumatici</Link></li>
                  <li><Link to="/carrello" className="hover:text-white transition-colors">Carrello</Link></li>
                </>
              )}
              <li><Link to="/ordini" className="hover:text-white transition-colors">I miei ordini</Link></li>
              <li><Link to="/profilo" className="hover:text-white transition-colors">Profilo</Link></li>
            </ul>
          </div>

          {/* Servizi */}
          <div>
            <h2 className="text-white font-bold text-xs uppercase tracking-widest mb-4">Servizi</h2>
            <ul className="space-y-2.5 text-sm">
              {["Cambio Gomme", "Convergenza", "Meccanica & Tagliando", "Revisione Auto", "Officine Mobili"].map(s => (
                <li key={s} className="text-gray-400">{s}</li>
              ))}
            </ul>
          </div>

          {/* Contatti */}
          <div className="col-span-2 md:col-span-1">
            <h2 className="text-white font-bold text-xs uppercase tracking-widest mb-4">Contatti</h2>
            <ul className="space-y-3 text-sm">
              <li>
                <a href="tel:+39069004128" className="flex items-center gap-2.5 hover:text-white transition-colors">
                  <div className="w-7 h-7 rounded-lg bg-white/5 flex items-center justify-center shrink-0"><Phone size={13} className="text-pg-red" /></div>
                  06 900 41 28
                </a>
              </li>
              <li>
                <a href="mailto:info@puntogommelazio.it" className="flex items-center gap-2.5 hover:text-white transition-colors">
                  <div className="w-7 h-7 rounded-lg bg-white/5 flex items-center justify-center shrink-0"><Mail size={13} className="text-pg-red" /></div>
                  info@puntogommelazio.it
                </a>
              </li>
              <li className="flex items-start gap-2.5">
                <div className="w-7 h-7 rounded-lg bg-white/5 flex items-center justify-center shrink-0 mt-0.5"><MapPin size={13} className="text-pg-red" /></div>
                <span className="text-gray-400">Via E. Ramarini 27/29<br />Monterotondo (RM)</span>
              </li>
              <li className="flex items-start gap-2.5">
                <div className="w-7 h-7 rounded-lg bg-white/5 flex items-center justify-center shrink-0 mt-0.5"><Clock size={13} className="text-pg-red" /></div>
                <span className="text-gray-400">Lun–Ven 8:30–18:30<br />Sab 8:30–12:30</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/[0.06] pt-6 flex flex-col sm:flex-row justify-between items-center gap-2 text-xs text-gray-400">
          <p>&copy; {new Date().getFullYear()} PuntoGommeLazio Srl. Tutti i diritti riservati.</p>
          <p>P.IVA 00000000000</p>
        </div>
      </div>
    </footer>
  );
}
